import {PRESCRIPTION_METHOD} from 'constants/product';
import {PRESCRIPTION_STATUS} from 'constants/success';
import {FieldType, ItemsType} from 'types/successPage';

import {getIsAllItemsOfOrderUpdated} from '../helpers/helpers';

/**
 * Converts the data into the format for backend
 */
export const convertDataToBackendFormat = (items: Array<FieldType>) =>
    items.reduce(
        (acc, orderItem) => ({
            ...acc,
            [orderItem.orderItemId]: {
                ...(orderItem.fileSrc
                    ? {
                          prescription: {
                              file: orderItem.fileSrc,
                              send_by: PRESCRIPTION_METHOD.UPLOAD_METHOD,
                          },
                      }
                    : {doctorDetails: orderItem.doctorDetails}),
            },
        }),
        {},
    );
/**
 * Gets the common prescription status of all items
 */
export const getCommonPrescriptionStatusAfterUpdateOrder = (
    items: ItemsType,
    itemCount: number = 1,
) => {
    const firstItemStatus = items?.[0]?.prescriptionStatus;
    const isAllSameStatus = items?.every(item => item.prescriptionStatus === firstItemStatus);
    const isAllItemsSuccess = getIsAllItemsOfOrderUpdated(items);

    if (isAllSameStatus && itemCount === 1) {
        return firstItemStatus;
    }

    if (
        items?.find(
            ({prescriptionStatus}) =>
                prescriptionStatus === PRESCRIPTION_STATUS.EYE_EXAM ||
                prescriptionStatus === PRESCRIPTION_STATUS.VISIBLY,
        ) &&
        items.every(({prescriptionStatus}) => prescriptionStatus)
    ) {
        return PRESCRIPTION_STATUS.EYE_EXAM;
    }

    if (itemCount > 1) {
        return isAllItemsSuccess
            ? PRESCRIPTION_STATUS.MIXED_ITEMS_SUCCESS
            : PRESCRIPTION_STATUS.MISSING_ITEM_PRESCRIPTION;
    }

    return '';
};
